import type {PathFunction} from './types'
import {encodePart} from './utils'

// Keep in sync with `org_settings_byok_custom_models_path` route helper in Rails.
export const orgSettingsByokCustomModelsPath: PathFunction<{org: string}> = ({org}) =>
  `/organizations/${encodePart(org)}/settings/custom-models`
